var path = '/client/common/modules/thumbnail/views/thumbnail.html';
var html = "<div class=\"ls-thumbnail\" ng-style=\"::vm.Utils.getBackgroundImage(vm.thumbnailSrc, vm.thumbnailWidth)\"></div>\n";
window.angular.module('AppTemplates').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;